<div class="flex-col flex-1 flex-grow50-gtsm gap-1em">

  <mat-form-field>
    <mat-label>{{'preferences.Language' | translate}}</mat-label>
    <mat-select [(ngModel)]="configurations.language">
      @for (language of languages; track language) {
        <mat-option [value]="language.locale">
          <span class="vertical-center">{{'preferences.' + language.name | translate}}@if (language.isDefault) {
            <i style="font-size: 0.75em;"> (default)</i>
          }</span>
        </mat-option>
      }
    </mat-select>
    <mat-hint>{{'preferences.LanguageHint' | translate}}</mat-hint>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{'preferences.HomePage' | translate}}</mat-label>
    <mat-select [(ngModel)]="configurations.homeUrl">
      <mat-select-trigger>
        <mat-icon class="vertical-center mat-button-icon">{{currentHomePage.icon}}</mat-icon><span class="vertical-center">{{currentHomePage.title}}</span>
      </mat-select-trigger>
      @for (page of homePages; track page) {
        <mat-option [value]="page.path">
          <mat-icon class="vertical-center">{{page.icon}}</mat-icon><span class="vertical-center">{{'preferences.' + page.title | translate}}@if (page.isDefault) {
          <i style="font-size: 0.75em;"> (default)</i>
        }</span>
      </mat-option>
    }
  </mat-select>
  <mat-hint>{{'preferences.HomePageHint' | translate}}</mat-hint>
</mat-form-field>

<div class="flex-col start-start gap-1em">
</div>

</div>
